/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import headerConfig from "../config/header.config.json";
import loadingConfig from "../config/loading.config.json";
import settingsConfig from "../config/settings.config.json";
import errorConfig from "../config/error.config.json";
import bulkImportConfig from "../config/userListsBulkImport.config.json";
import notificationConfig from "../config/notifications.config.json";
import inviteUserConfig from '../config/inviteUser.config.json';
import inviteUserByEmailConfig from '../config/inviteUserByEmailForm.config.json';
import createMasqConfig from "../config/createMasquerader.config.json";
import inviteFormData from "../config/inviteUserForm.config.json";
import bulkInviteFormData from "../config/bulkInviteUserForm.config.json";
import memberDetail from "../config/memberDetail.config.json";
import sendDiscount from "../config/sendDiscount.config.json";
import { VApplication } from "../../../application";
import formData from "../config/createsUserForm.config.json";
import { BreadcrumbService } from "../../breadcrumbService";

export interface IStaticPageContentMethods extends IPluginMethodMap {
  getStaticPageContentSync(args: any): any;
}

const getBreadcrumbService = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.BreadcrumbService") as BreadcrumbService;
};

export class StaticPageContentService implements IAgentPlugin {
  readonly methods: IStaticPageContentMethods;

  constructor() {
    this.methods = {
      getStaticPageContentSync: this.getProps.bind(this),
    };
  }

  getProps(args: any) {
    const srv = getBreadcrumbService();
    const breadcrumbItems = srv?.getBreadCrumbItems();
    return {
      header: { ...headerConfig, ...(breadcrumbItems || {}) },
      loading: loadingConfig,
      userListImport: bulkImportConfig,
      settings: settingsConfig,
      notifications: notificationConfig,
      error: errorConfig,
      inviteUser: inviteUserConfig,
      createMasq: createMasqConfig,
      formData: formData,
      sendDiscount: sendDiscount,
      inviteFormData: inviteFormData,
      bulkInviteFormData: bulkInviteFormData,
      inviteByEmailmData: inviteUserByEmailConfig,
      memberDetail: memberDetail
    };
  }
}
